import { ResetPasswordForm } from "@/components/auth";
import { useLoginRouting } from "@/hooks";

export const ResetPasswordPage = () => {
  useLoginRouting();

  return (
    <div className="flex-row flex-grow justify-center my-auto">
      <div className="flex flex-row justify-center">
        <div className="border-2 shadow-lg p-8 bg-white rounded-xl">
          <div className="mt-4">
            <ResetPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
};
